module.exports = __webpack_public_path__ + "static/media/slimakova.7f236353.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/slimakova.jpg
// module id = 556
// module chunks = 0